import { z } from "zod";
import { defineWidget } from "@/lib/home/widget";

import { RECENT_ROWS } from "./rows";

/** Today's "Recent" list, now a widget: the last chats and searches in this workspace. */
export default defineWidget({
  type: "kourai.recent",
  version: 1,
  title: "Recent",
  description: "Your last chats and searches",
  sizes: ["m", "l", "w", "xl"],
  defaultSize: "xl",
  surfaces: ["newtab", "sidepanel"],
  data: "none",
  permissions: [],
  max: 1,
  config: z.object({
    rows: z
      .number()
      .int()
      .refine((n) => (RECENT_ROWS as readonly number[]).includes(n))
      .default(5),
  }),
  load: () => import("./recent-widget"),
});
